export const path = "/alertsAluna";
export const component = () => import("./index.jsx");
export const sidebar = {
  title: "ALERTAS",
  section: "ALUNA",
  group: null,
  order: 7,
  roles: [
    "Authenticated",
    "aluna",
    "aluna-management",
    "aluna-afiliado",
  ],
};
